var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconZoomInLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconZoomIn",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M854.397 1594.874c-408.288 0-740.477-332.19-740.477-740.477 0-408.288 332.189-740.477 740.477-740.477 408.287 0 740.477 332.189 740.477 740.477 0 408.287-332.19 740.477-740.477 740.477ZM1920 1839.345l-423.325-423.211c131.577-150.488 212.118-346.543 212.118-561.737C1708.793 383.225 1325.568 0 854.397 0 383.225 0 0 383.225 0 854.397c0 471.17 383.225 854.396 854.397 854.396 215.08 0 411.363-80.54 561.737-212.118L1839.345 1920l80.655-80.655ZM911.356 455.678h-113.92v341.759H455.679v113.92h341.759v341.758h113.92V911.356h341.758v-113.92h-341.76V455.679Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconZoomInLine.glyphName = 'zoom-in';
IconZoomInLine.variant = 'Line';
IconZoomInLine.displayName = 'IconZoomInLine';
IconZoomInLine.allowedProps = [...SVGIcon.allowedProps];
export default IconZoomInLine;
export { IconZoomInLine };